import React from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";
import { CustomButton } from "../../../../../../../../Components";
import { getDownloadableLink } from "../../../../../../../../Helper";
import { useSelectedTheme, useTranslate } from "../../../../../../../../Hooks";
import { image } from "suneditor/src/plugins";

// Icons
import { CloseXIcon } from "../../../../../../../../assets/icons";

// styles
import useStyles from "./styles";

export default function GalleryPreviewModal({
  open,
  onClose,
  images = [],
  initialIndex = 0,
}) {
  const styles = useStyles();
  const { translate } = useTranslate("NewPropertiesView");
  const {
    theme: { palette },
  } = useSelectedTheme();

  const hasImages = images && images.length > 0;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      PaperProps={{
        style: {
          borderRadius: 0,
          width: "100vw",
          height: "100vh",
          maxWidth: "100vw",
          maxHeight: "100vh",
          background: styles.modalRoot?.background,
          boxShadow: "none",
        },
        className: styles.modalRoot,
      }}
    >
      <Box className={styles.modalRoot}>
        {/* Header with close button */}
        <Box className={styles.headingContainer}>
          <Box className={styles.titlesWrapper}>
            <DialogTitle
              className={styles.dialogTitleWrapper}
              id="custom-dialog-title"
            >
              <div className={styles.dialogTitle}>
                <Box className={styles.containerTitle}>
                  {translate("galleryPreview.title")}
                </Box>
              </div>
            </DialogTitle>
            <CloseXIcon
              onClick={onClose}
              style={{
                cursor: "pointer",
                position: "Absolute",
                right: "0px",
                top: "0px",
              }}
              width="24"
              height="24"
              fill={palette.foreground.quinary}
            />
            <Typography variant="body2" className={styles.subtitle}>
              {translate("galleryPreview.subtitle")}
            </Typography>
          </Box>
        </Box>
        {/* Thumbnails row */}
        <Box className={styles.thumbnailsRow}>
          {hasImages &&
            images.map((img, idx) => (
              <Box key={img.fileId || idx} className={styles.thumbnailBox}>
                <img
                  src={getDownloadableLink(img.fileId)}
                  alt={img.fileName || `Photo ${idx + 1}`}
                  className={styles.thumbnailImg}
                />
              </Box>
            ))}
        </Box>
        {/* Responsive grid of large images */}
        <Box className={styles.gridImages}>
          {hasImages &&
            images
              .reduce(
                (acc, _, i) =>
                  i % 5 === 0 ? [...acc, images.slice(i, i + 5)] : acc,
                []
              )
              .map((section, idx) => (
                <Box key={idx} className={styles.imageSection}>
                  <Box className={styles.leftColumn}>
                    {section.slice(0, 4).map((img, i) => (
                      <Box className={styles.containerItemImageLeft}>
                        <img
                          key={img.fileId || i}
                          src={getDownloadableLink(img.fileId)}
                          alt={img.fileName || `Photo ${i + 1}`}
                          className={styles.gridImg}
                        />
                      </Box>
                    ))}
                  </Box>
                  {section[4] && (
                    <Box className={styles.rightColumn}>
                      <img
                        key={section[4].fileId}
                        src={getDownloadableLink(section[4].fileId)}
                        alt={section[4].fileName || "Photo"}
                        className={styles.gridImg}
                      />
                    </Box>
                  )}
                </Box>
              ))}
        </Box>
        <DialogActions className={styles.dialogActions}>
          <CustomButton
            boxShadow="xs"
            size="lg"
            variant="outlined"
            color="secondary"
            onClick={onClose}
          >
            {translate("cancel")}
          </CustomButton>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
